import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.remove', {
        url: '/remove',
        component: 'companyManageApplicationRemove',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remove/remove-application.state.js